import { MAP_TYPES } from '@deck.gl/carto';

const CUSTOMSQL_SECONDARY_SOURCE_ID = 'customSqlSecondarySource';

const source = {
  id: CUSTOMSQL_SECONDARY_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: undefined,
  data: undefined,
};

export default source;
